import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { COLOR_GREY_600 } from 'src/colors';

const UnlockCTAButton = ({
  text,
  handleClick,
  invert,
  padding,
  icon,
}: {
  text: string;
  handleClick: () => void;
  invert?: boolean;
  padding?: string;
  icon?: JSX.Element;
}) => {
  return (
    <Grid style={{ width: '250px', marginRight:'10px' }}>
      <Box
        sx={{
          position: 'relative',
          padding: padding ? padding : '15px 30px',
          // marginTop: '-10px',
          background: 'linear-gradient(273.52deg, #7158E2 29.31%, #FF2079 97.77%)',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
          borderRadius: '200px',
          color: invert ? COLOR_GREY_600 : '#fff',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'all 0.5s ease',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.35)',
          },
          overflow: 'hidden',
        }}
        onClick={handleClick}
      >
        {invert && (
          <div
            style={{
              width: 'calc(100% - 70px)',
              height: 'calc(100% - 36px)',
              background: '#fff',
              borderRadius: 200,
              color: invert ? COLOR_GREY_600 : '#fff',
              padding: invert ? '13px 28px' : '0',
              position: 'absolute',
            }}
          />
        )}
        <Typography
          style={{
            fontWeight: 700,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          {icon && icon}
          {text}
        </Typography>
      </Box>
    </Grid>
  );
};

export default UnlockCTAButton;
